<form>
    <mat-form-field appearance="fill" class="defaultFill">
        <mat-label>{{label}}</mat-label>
        <mat-select [(value)]="selectedValue" (selectionChange)="updateSelectedValue($event.value)">
            <mat-option *ngFor="let currentItem of values" [value]="currentItem.value">
                {{currentItem.displayValue}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>